// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__4ZChC","modal":"Modal_modal__Kki0I","slide-down":"Modal_slide-down__pNTxN"};